export const verifyEmailLink = `${process.env.REACT_APP_PATH}/log-in`;
